import React from 'react';
import { Modal, Button } from 'react-bootstrap';

/**
 * Dialog — generic reusable modal for Mission Control.
 *
 * Props:
 *   show           — boolean
 *   title          — string
 *   onHide         — () => void  (called on Cancel or backdrop click)
 *   onSubmit       — () => void  (called on primary button click)
 *   submitLabel    — string (default: 'OK')
 *   submitDisabled — boolean
 *   children       — modal body content
 */
function Dialog({ show, title, onHide, onSubmit, submitLabel = 'OK', submitDisabled, children }) {
  // Enter submits from a single-line field, and only from one. In a TEXTAREA it is a paragraph
  // break: the descriptions these dialogs collect are prose, and a form that closed itself on the
  // first Return could not take a second line of it. (Nothing needed saying while the description
  // was an Ace editor, which swallowed the key itself — the moment it became a plain textarea, this
  // handler was the whole difference between a multi-line field and a one-line one.)
  const handleKeyDown = (e) => {
    if (e.key !== 'Enter' || submitDisabled) return;
    if (e.target && e.target.tagName === 'TEXTAREA') return;
    if (onSubmit) onSubmit();
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body onKeyDown={handleKeyDown}>
        {children}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={onHide}>Cancel</Button>
        <Button variant="success" disabled={submitDisabled} onClick={onSubmit}>
          {submitLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default Dialog;
